import { HomePage } from '~/__generated_types__/globalTypes'

import { Page } from '~/app/types'

const NETWORK = 'network'
const NETWORK_LOAD = 'networkLoad'

const ryderShareAuthenticatedPages: Readonly<Array<Page>> = [
  {
    key: 'customerVisibility',
    path: '/rydershare/visibility',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Visibility',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'TruckIcon',
  },
  {
    key: 'customerVisibilityExceptions',
    path: '/rydershare/visibility/exceptions',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Visibility',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
    featureFlag: 'shouldShowExceptionsDashboardCvt',
  },
  {
    key: 'customerVisibilityDetail',
    path: '/rydershare/visibility/:loadId',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Visibility',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: NETWORK,
    path: '/network',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Network',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
  {
    key: NETWORK_LOAD,
    path: '/network/load/:loadId',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Network',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
]

const tmCustomerAuthenticatedPages: Readonly<Array<Page>> = [
  {
    key: 'customerVisibilityDetail',
    path: '/rydershare/visibility/:loadId',
    title: '(BETA)',
    subTitle: 'Shipments',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'shipments',
    path: '/shipments',
    title: '(BETA)',
    subTitle: 'Shipments',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'PackageIcon',
  },
  {
    key: 'shipmentsDetail',
    path: '/shipments/:shipmentId',
    title: '(BETA)',
    subTitle: 'Shipments',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'PackageIcon',
  },
  {
    key: 'shipmentsLoadDetail',
    path: '/shipments/:shipmentId/load/:loadId',
    title: '(BETA)',
    subTitle: 'Shipments',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'PackageIcon',
  },
  {
    key: NETWORK,
    path: '/network',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Network',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
  {
    key: NETWORK_LOAD,
    path: '/network/load/:loadId',
    title: '(BETA)',
    subTitle: 'Network',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
]

const integratedCustomerAuthenticatedPages: Readonly<Array<Page>> = [
  {
    key: 'visibility',
    path: '/tracking',
    title: '(BETA)',
    subTitle: 'Visibility',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'MapPinAreaIcon',
  },
  {
    key: 'visibilityLoadDetail',
    path: '/tracking/load/:loadId',
    title: '(BETA)',
    subTitle: 'Visibility',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'MapPinAreaIcon',
  },
  {
    key: 'visibilityShipmentDetail',
    path: '/tracking/shipment/:shipmentId',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Visibility',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'MapPinAreaIcon',
  },
  {
    key: 'visibilityShipmentLoadDetail',
    path: '/tracking/shipment/:shipmentId/load/:loadId',
    title: '(BETA)',
    subTitle: 'Visibility',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'MapPinAreaIcon',
  },
  {
    key: 'visibilityLoadShipmentDetail',
    path: '/tracking/load/:loadId/shipment/:shipmentId',
    title: '(BETA)',
    subTitle: 'Visibility',
    logo: 'rydershare',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'MapPinAreaIcon',
  },
  {
    key: NETWORK,
    path: '/network',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Network',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
  {
    key: NETWORK_LOAD,
    path: '/network/load/:loadId',
    title: '(BETA)',
    logo: 'rydershare',
    subTitle: 'Network',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'GlobeHemisphereWestIcon',
    featureFlag: 'shouldShowNetworkPageCvt',
  },
]

const operationalAuthenticatedPages: Readonly<Array<Page>> = [
  {
    key: 'home',
    path: '/home',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'Driver Vis',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'dispatch',
    path: '/dispatch',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'Driver Vis',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'dispatch',
    path: '/dispatch/:id',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'dispatch',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'monitor',
    path: '/monitor',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'monitor',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'monitor',
    path: '/monitor/:id',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'monitor',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'review',
    path: '/review',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'review',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'review',
    path: '/review/:id',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'review',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'TruckIcon',
  },
  {
    key: 'visibility',
    path: '/visibility',
    title: 'Driver Visibility',
    logo: 'driverVisibility',
    subTitle: 'Driver Vis',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'TruckIcon',
  },
  {
    key: 'loads',
    path: '/all-loads',
    title: 'Load Board',
    logo: 'loadBoard',
    subTitle: 'Load Board',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'ArticleIcon',
  },
  {
    key: 'loadsDetail',
    path: '/all-loads/:loadId',
    title: '',
    isNavigable: true,
    isOnSidebar: false,
    iconName: 'ArticleIcon',
  },
  {
    key: 'dataManagement',
    path: '/datamanagement',
    title: 'Data',
    logo: 'dataManagement',
    subTitle: 'Data',
    isNavigable: true,
    isOnSidebar: true,
    featureFlag: 'showFacilityManagement',
    iconName: 'ListBulletsIcon',
  },
  {
    key: 'dataManagementFacilityDetail',
    path: '/datamanagement/facilities/:facilityId',
    title: '',
    subTitle: 'Data',
    isNavigable: true,
    isOnSidebar: false,
    featureFlag: 'showFacilityManagement',
    iconName: 'ListBulletsIcon',
  },
  {
    key: 'dataManagementFacilityDetail',
    path: '/datamanagement/tractors/:tractorId',
    title: '',
    subTitle: 'Data',
    isNavigable: true,
    isOnSidebar: false,
    featureFlag: 'showEquipmentManagement',
    iconName: 'ListBulletsIcon',
  },
  {
    key: 'dataManagementFacilityDetail',
    path: '/datamanagement/trailers/:trailerId',
    title: '',
    subTitle: 'Data',
    isNavigable: true,
    isOnSidebar: false,
    featureFlag: 'showEquipmentManagement',
    iconName: 'ListBulletsIcon',
  },
  {
    key: 'planningBoard',
    path: '/planningboard',
    title: 'Planning Board',
    logo: 'planningBoard',
    subTitle: 'Planning',
    isNavigable: true,
    isOnSidebar: true,
    iconName: 'CalendarDotIcon',
    featureFlag: 'showPlanningBoardToOperator',
  },
]

const sysadminAuthenticatedPages: Readonly<Array<Page>> = [
  {
    key: 'admin-control-center',
    path: '/admin-control-center',
    title: 'Admin Control Center',
    iconName: 'UserGearIcon',
    isOnSidebar: false,
    isNavigable: true,
  },
]

const DEFAULT_OPERATOR_HOME_PAGE = HomePage.Loadboard

export enum ShellMode {
  Pending = 'pending',
  NewLayout = 'new-layout',
  LegacyLayout = 'legacy-layout',
}

export {
  ryderShareAuthenticatedPages,
  operationalAuthenticatedPages,
  sysadminAuthenticatedPages,
  tmCustomerAuthenticatedPages,
  DEFAULT_OPERATOR_HOME_PAGE,
  integratedCustomerAuthenticatedPages,
  NETWORK,
  NETWORK_LOAD,
}
